import React from "react";
import Router from "./Route";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// On this we only load Router and Toast Container
// More detailed code is in the Router
function App() {
  return (
    <>
			<Router />
      {/* Put default toast on the top right */}
			<ToastContainer draggable={false} position={toast.POSITION.TOP_CENTER} />
		</>
	);
}

export default App;
